import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-slate-950" data-id="element-85" data-mp="129h0vnss70df">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-86" data-mp="127efjh2kpvf1">
        <span className="flex-1 bg-slate-600" data-id="element-87" data-mp="xbflbcukdj6p" />
        <span className="w-24 bg-yellow-400" data-id="element-88" data-mp="x8jmlmaw6qh7" />
        <span className="flex-1 bg-slate-600" data-id="element-89" data-mp="sai16upzuf2k" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-90" data-mp="sd48ct8z2sk9">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-yellow-400/50 bg-blue-950 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-stone-50" data-id="element-91" data-mp="neknkw647mth">
          <ZapIcon className="h-4 w-4 shrink-0 text-yellow-400" aria-hidden="true" data-id="element-92" data-mp="3o73o289n1o6h" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-93" data-mp="3e9frdcsh26lo">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-[0_0_36px_rgba(251,191,36,0.28)]" data-id="element-94" data-mp="35a2h4hwixdzw" />
        </motion.div>

        <div className="mt-9" data-id="element-95" data-mp="2vies0nnfw91l">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-96" data-mp="2vjg6l23nzdo2">
            Get your professional edition now
          </Button>
        </div>
      </div>
    </section>;
}